<template>
  <div v-if="question" class="question-title">
    <h2 class="question-choice">{{ question.intro }}</h2>

    <div class="content-wrapper">
      <div style="display: flex; justify-content: center;">
        <div
          v-for="option in question.config.options"
          :key="option.value"
          class="position-relative"
        >
          <label class="w-100 h-100 my-0">

            <float-label>
                <input
                  :id="option.value"
                  class="form-control input-freetext"
                  rows="4"
                  :placeholder="option.info"
                  @input="update"
                  v-model="inputtext"/>
              </float-label>
          </label>
          <div
            v-if="!$v.inputtext.validator"
            class="invalid-feedback"
          >
            {{option.info}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helpers, numeric, required } from 'vuelidate/lib/validators';

export default {
  name: 'reference-text-question',
  data() {
    return {
      inputtext: "",
    }
  },
  validations() {
    let valString = this.$store.state.questions[0].config.options[0].validation
    let regexValString = new RegExp(valString)
    const validator = helpers.regex('validator', regexValString);
    return {
      inputtext: { numeric, validator, required }
    }
  },
  computed: {
    question: function () {
      return this.$store.state.questions[0] || false
    }
  },
  mounted() {
    if(this.$store.state.questions[0].selectedAnswers != null){
      this.inputtext = this.$store.state.questions[0].selectedAnswers.displayValue;
    } else {
      this.inputtext = "";
    }
  },

  methods: {
    update(e) {
      if(this.$v.inputtext.validator && this.$v.inputtext.required) {
        this.$store.commit('updateSelectedAnswers', { answer: e.target.id, displayValue: this.inputtext});
      } else {
        this.$store.commit('clearSelectedAnswers');
      }
    }
  },
}
</script>
